<template>
  <div class="main_body livestream_page">

    <section id="hero_section">
      <div class="container">
        <!-- navbar starts -->
        <navbar></navbar>

        <!-- navbar ends -->

        <div class="main_logo">
          <img src="@/assets/images/Logo-011.png" alt="Logo-011.png">
        </div>

        <!-- youtube starts -->
        <section class="youtube_section">
          <!-- subscribe box -->
          <youtube-banner :type="'hyperlink'"></youtube-banner>
          <!-- latest music list -->
          <section class="social_section available_section">
            <div class="available_companies">
              <div class="row">
                <div class="col-md-3 col-6">
                  <div class="company_logo before">
                    <div class="company_logo_box">
                      <img src="@/assets/images/spotify_sm.svg" alt="spotify_sm.svg" class="logo_img">
                      <img src="@/assets/images/black_play.svg" alt="black_play.svg">
                      <a href="https://open.spotify.com/artist/3UGhltIiwrExCxs5CjJQFh?si=enFsVQOiSeOIhTQja9L7FQ&utm_source=copy-link&dl_branch=1" target="_blank" class="stretched-link"></a>

                    </div>
                  </div>
                </div>
                <div class="col-md-3 col-6">
                  <div class="company_logo before">
                    <div class="company_logo_box">
                      <img src="@/assets/images/youtube_sm.svg" alt="youtube_sm.svg" class="logo_img">
                      <img src="@/assets/images/black_play.svg" alt="black_play.svg">
                      <a href="https://music.youtube.com/channel/UCPXvcvwq0-Qfht1rJAFLTzQ" target="_blank" class="stretched-link"></a>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 col-6">
                  <div class="company_logo">
                    <div class="company_logo_box">
                      <img src="@/assets/images/apple-music-sm.svg" alt="apple-music-sm.svg" class="logo_img">
                      <img src="@/assets/images/black_play.svg" alt="black_play.svg">
                      <a href="https://music.apple.com/us/artist/gm-nanashi/1561494105" target="_blank" class="stretched-link"></a>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 col-6">
                  <div class="company_logo company_logo4">
                    <div class="company_logo_box">
                      <img src="@/assets/images/vertical_orange_sm.svg" alt="vertical_orange_sm.svg" class="logo_img">
                      <img src="@/assets/images/black_play.svg" alt="black_play.svg">
                      <a href="https://soundcloud.app.goo.gl/jbjzJ" target="_blank" class="stretched-link"></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <latest-music :showHeading="false"></latest-music>

        </section>
      </div>
        <!-- youtube ends -->
    </section>
    <div class="container">
    </div>
  </div>
</template>

<script>
import LatestMusic from '../components/LatestMusic.vue'
import Navbar from '../components/Navbar.vue'
import YoutubeBanner from '../components/YoutubeBanner.vue'
export default {
  components: { Navbar, LatestMusic, YoutubeBanner },
  name: 'HyperLink',
  data () {
    return {}
  },
  methods: {}
}

</script>

<style scoped>
@media (max-width: 575.98px) {
  .livestream_page .social_section.available_section .company_logo.before:before {
    content: '';
    position: absolute;
    background-color: #898989;
    right: 0;
    height: 1px;
    width: 120px;
    top: calc(100% - 10px);
    left: 19%;
  }
  .livestream_page .social_section.available_section {
    padding: 20px 0px 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/HyperLink.vue